import { SxProps, Typography } from '@mui/material';
import React from 'react';
import {
  BorderRadius,
  ColorPalette,
  TypographyFamily,
} from '../../../styles/constants';
import AddIcon from '@mui/icons-material/Add';
import { LoadingButton, LoadingButtonProps } from '@mui/lab';

interface Props extends LoadingButtonProps {
  handleClick?: () => void;
  sx?: SxProps;
  isIconButton?: boolean;
  isDisabled?: boolean;
  label: string;
  type?: 'submit' | 'button';
}

export function AppButtonContained({
  handleClick,
  sx,
  isIconButton = false,
  isDisabled = false,
  label,
  type = 'button',
  ...props
}: Props): JSX.Element {
  return (
    <LoadingButton
      {...props}
      type={type}
      onClick={handleClick}
      disabled={isDisabled}
      sx={{
        fontFamily: TypographyFamily.NEXA,
        fontWeight: 800,
        boxShadow: 'none',
        border: '2px solid transparent',
        background: isDisabled
          ? ColorPalette.DARK_GRAY
          : ColorPalette.GRADIENT_CONTAINED_BUTTON,
        color: ColorPalette.WHITE,
        borderRadius: BorderRadius.SMALL,

        '&:hover': {
          background: ColorPalette.GRADIENT_CONTAINED_HOVER,
          boxShadow: 'none',
        },

        '&.MuiLoadingButton-loading': {
          opacity: 0.7,
          background: ColorPalette.DARK_GRAY,
        },

        '&.MuiLoadingButton-loadingIndicator': {
          colors: ColorPalette.WHITE,
        },
        ...sx,
      }}
    >
      {isIconButton && <AddIcon sx={{ mr: 1 }} />}
      <Typography
        sx={{
          ...sx,
          px: 1,
          py: isIconButton ? 'auto' : 0.15,
          mt: 0.5,
          fontFamily: TypographyFamily.NEXA,
          fontSize: '16px',
          fontWeight: 800,
          lineHeight: '18px',
          color: props.loading ? 'transparent' : ColorPalette.WHITE,
          textAlign: 'center',
        }}
      >
        {label}
      </Typography>
    </LoadingButton>
  );
}
